import PropTypes from 'prop-types'
import { branch, compose, getContext } from 'recompose'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { selectCurrentLoans } from 'src/store/selectors/home/loans'
import { withAdditionalInfoToggle, withQueryParams } from 'src/composables'
import {
  selectCurrentAVM,
  selectAVMEquity,
  selectOutstandingPrincipal
} from 'src/store/selectors/home/avm'
import { selectCurrentAVMMap } from 'src/store/selectors/homePreview'

const composeWithHomeData = compose(
  connect(state => ({
    avm: selectCurrentAVM(state),
    outstandingPrincipal: selectOutstandingPrincipal(state),
    estimatedValue: selectAVMEquity(state),
    hasLoans: Boolean(selectCurrentLoans(state).length)
  }))
)

const composeWithoutHomeData = compose(
  withQueryParams,
  connect((state, { id }) => {
    const avm = selectCurrentAVMMap(state)[id]
    const amount = get(avm, 'amount')

    return {
      avm: amount,
      hasLoans: false,
      outstandingPrincipal: 0,
      estimatedValue: amount
    }
  })
)

const NetWorthSectionContainer = compose(
  getContext({ withCurrentHomeData: PropTypes.bool }),
  branch(
    ({ withCurrentHomeData }) => withCurrentHomeData,
    composeWithHomeData,
    composeWithoutHomeData
  ),
  withAdditionalInfoToggle
)

export default NetWorthSectionContainer
